import React from 'react';
import AsyncPage from './async';
import {Route} from 'react-router-dom';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <Route key="/business/user/setup-password" element={<DefaultBusinessLayout />}>
    <Route path="business/user/setup-password" element={<AsyncPage />} />
  </Route>,
];
